module.exports = __webpack_public_path__ + "res/28-img_info_b.7977c42c52eee6f766c512105ffb1408.png";